import { useState } from 'react'

import { type IRole } from '@/app/types/authType'
import { Loader, PageWrapper } from '@/shared'
import { type ISwapSequencs } from '@App/types/common'
import {
    type ISectionRulesWrapper,
    type ICategoryDto,
    type IChildServiceDec,
    type IServiceDec
} from '@App/types/servicesTypes'

import { AddCategoryModal } from './AddCategoryModal/AddCategoryModal'
import style from './Categories.module.scss'
import { CategoriesList } from './CategoriesList/CategoriesList'
import { SectionRulesModal } from './SectionRulesModal/SectionRulesModal'
// import { Control } from './Control/Control'

interface IProps {
    isFetching: boolean
    categoriesList: IServiceDec[] | null
    adminRoles?: IRole[]
    sectionRules: ISectionRulesWrapper | null
    onSwapServices: (dto: ISwapSequencs) => void
    onSwapCategories: (dto: ISwapSequencs) => void
    onChangeRules: (dto: ISectionRulesWrapper, onSuccess?: () => void, withFetching?: boolean) => void
    onSetSectionRules: (sectionRules: ISectionRulesWrapper | null) => void
    onGetSectionsRules: (id: string) => void
    onSetTranferSevice: (tranferSevice: IChildServiceDec | null) => void
    onAddCategory: (dto: ICategoryDto, onSuccess: () => void) => void
    onRemoveCategory: (id: string, onSuccess: () => void) => void
    onEditCategory: (dto: ICategoryDto, onSuccess: () => void) => void
    onAddSection: (dto: ICategoryDto, onSuccess: () => void) => void
    onRemoveSection: (id: string, onSuccess: () => void) => void
}

export const Categories = (props: IProps) => {
    const {
        isFetching,
        categoriesList,
        adminRoles,
        sectionRules,
        onSwapServices,
        onSwapCategories,
        onChangeRules,
        onSetSectionRules,
        onGetSectionsRules,
        onSetTranferSevice,
        onAddCategory,
        onRemoveCategory,
        onEditCategory,
        onAddSection,
        onRemoveSection
    } = props

    const [addCategoryModal, setAddCategoryModal] = useState<boolean>(false)

    return (
        <>
            {sectionRules && (
                <SectionRulesModal
                    sectionRules={sectionRules}
                    onSetSectionRules={onSetSectionRules}
                    onChangeRules={onChangeRules}
                    isFetching={isFetching}
                />
            )}
            {addCategoryModal && (
                <AddCategoryModal
                    show={addCategoryModal}
                    onClose={() => setAddCategoryModal(false)}
                    onAddCategory={onAddCategory}
                />
            )}
            {!categoriesList && <Loader className={style.laoder} />}
            {categoriesList && (
                <PageWrapper>
                    <div className={style.container}>
                        <CategoriesList
                            categoriesList={categoriesList}
                            adminRoles={adminRoles}
                            onSwapServices={onSwapServices}
                            onSwapCategories={onSwapCategories}
                            onGetSectionsRules={onGetSectionsRules}
                            onSetTranferSevice={onSetTranferSevice}
                            onRemoveCategory={onRemoveCategory}
                            onEditCategory={onEditCategory}
                            onAddSection={onAddSection}
                            onRemoveSection={onRemoveSection}
                            onEditSection={onEditCategory}
                        />
                    </div>
                </PageWrapper>
            )}
        </>
    )
}
